import { HStack, Text } from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons';
import ChangeRoleModal from '../../modals/ChangeRoleModal';

const ChangeRole = ({ isOpen, onClose, text, selectedAccount }) => {
  return (
    <>
      <HStack>
        <EditIcon />
        {text && <Text>{text}</Text>}
      </HStack>
      <ChangeRoleModal
        isOpen={isOpen}
        onClose={onClose}
        selectedAccount={selectedAccount}
      />
    </>
  );
};

export default ChangeRole;
